export const Logo = ({ className = "h-7", onClick }) => (
  <a
    href="#top"
    onClick={onClick}
    data-testid="brand-logo"
    className="inline-flex items-center select-none"
    aria-label="Sanvalio home"
  >
    <img src="/logo.png" alt="Sanvalio" className={`w-auto object-contain ${className}`} />
  </a>
);
